import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { ValueVisualKind } from "../types/quiz";
import { DigestionEffortVisual } from "./DigestionEffortVisual";
interface FlowRowProps {
  label: string;
  steps: string[];
  tone: "alert" | "calm";
}
function FlowRow({
  label,
  steps,
  tone
}: FlowRowProps) {
  const chip = tone === "alert" ? "bg-coral-100 text-coral-600" : "bg-olive-100 text-olive-700";
  return <div data-id="element-436" data-mp="2c0wjd50wqij2">
      <p className={`mb-2 text-xs font-semibold ${tone === "alert" ? "text-coral-600" : "text-olive-700"}`} data-id="element-437" data-mp="2c14uoshdtfs5">{label}</p>
      <div className="flex flex-wrap items-center gap-2" data-id="element-438" data-mp="2gz6czb6zhb2k">
        {steps.map((s, i) => <React.Fragment key={s} data-id="element-439" data-mp="2lx7uvssob4cg" data-mpi={i}>
            <span className={`rounded-full px-3 py-1.5 text-sm font-medium ${chip}`} data-id="element-440" data-mp="2m0dnhi0igocx">{s}</span>
            {i < steps.length - 1 && <ArrowRightIcon className="h-4 w-4 text-cocoa-faint" aria-hidden="true" data-id="element-441" data-mp="182135cx2n20" />}
          </React.Fragment>)}
      </div>
    </div>;
}
export function ValueVisual({
  kind
}: {
  kind: ValueVisualKind;
}) {
  if (kind === "digestion") return <DigestionEffortVisual data-id="element-442" data-mp="1w9aisnw7lih9" />;
  if (kind === "calories") {
    return <div className="flex items-center justify-center gap-3 rounded-2xl bg-white px-4 py-5 text-center" data-id="element-443" data-mp="1raz7s9u6h1xg">
        <span className="font-serif text-lg text-cocoa sm:text-xl" data-id="element-444" data-mp="1n94797k2mskq">Pocas calorías</span>
        <span className="font-serif text-3xl text-coral-600" aria-label="no es igual a" data-id="element-445" data-mp="1ibc3nga2di0p">≠</span>
        <span className="font-serif text-lg text-cocoa sm:text-xl" data-id="element-446" data-mp="1dbg1lmkxg0ns">Fácil digestión nocturna</span>
      </div>;
  }
  if (kind === "stress") {
    return <div className="space-y-4 rounded-2xl bg-white p-5" data-id="element-447" data-mp="18jg6c7fsxvxj">
        <FlowRow label="Modo alerta" steps={["Estrés activo", "Digestión lenta"]} tone="alert" data-id="element-448" data-mp="13lemvlegrulj" />
        <FlowRow label="Modo calma" steps={["Calma", "Digestión más eficiente"]} tone="calm" data-id="element-449" data-mp="zkuo6de8sixa" />
      </div>;
  }
  return <div className="space-y-4 rounded-2xl bg-white p-5" data-id="element-450" data-mp="ulhv3aws2fm9">
      <FlowRow label="Sin plan" steps={["Improvisación", "Hinchazón"]} tone="alert" data-id="element-451" data-mp="un2pn0j3dyk4" />
      <FlowRow label="Con plan" steps={["Cena simple", "Descanso"]} tone="calm" data-id="element-452" data-mp="po84vt1kdzxd" />
    </div>;
}